module.exports = __webpack_public_path__ + "img/baja_icon.6647196e.svg";